export enum OrderScreen {
  Dashboard,
  Details
}
